import React from 'react';

interface ProcessStep {
  id: string;
  text: string;
  icon: React.ReactNode;
  color: string;
  position: string;
  animationDelay: string;
}

interface AgentProcessVisualizerProps {
  agentType: string;
  steps: ProcessStep[];
}

const AgentProcessVisualizer: React.FC<AgentProcessVisualizerProps> = ({ agentType, steps }) => {
  return (
    <div className="absolute top-0 sm:top-6 left-0 right-0 h-44 sm:h-48 pointer-events-none">
      {/* Process Steps */}
      {steps.map((step, index) => (
        <div key={step.id} className={`absolute ${step.position}`}>
          <div 
            className={`flex items-center space-x-1 bg-bg-surface/80 backdrop-blur-sm border border-${step.color}/30 rounded-lg px-1 py-0.5 sm:px-2 sm:py-1.5`}
            style={{ 
              animationDelay: step.animationDelay,
              animation: index % 2 === 0 ? 'animate-pulse 2s infinite' : 'animate-bounce 2s infinite'
            }}
          >
            <div className="w-2.5 h-2.5 sm:w-3 sm:h-3">
              {step.icon}
            </div>
            <span className={`text-[0.65rem] sm:text-xs text-${step.color} font-medium`}>
              {step.text}
            </span>
          </div>
        </div>
      ))}

      {/* Process Flow Lines */}
      <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 300 200" style={{ opacity: 0.3 }}>
        <defs>
          <linearGradient id={`processFlow-${agentType}`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#2F7BFF" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#12E6A5" stopOpacity="0.4" />
          </linearGradient>
        </defs>
        
        {/* Flow lines connecting the process steps */}
        <path d="M80,20 Q150,30 220,20" stroke={`url(#processFlow-${agentType})`} strokeWidth="1" strokeDasharray="2,4" fill="none" className="lead-scan-line" />
        <path d="M80,70 Q150,80 220,70" stroke={`url(#processFlow-${agentType})`} strokeWidth="1" strokeDasharray="2,4" fill="none" className="lead-scan-line" style={{ animationDelay: '1s' }} />
        <path d="M80,160 Q150,150 220,160" stroke={`url(#processFlow-${agentType})`} strokeWidth="1" strokeDasharray="2,4" fill="none" className="lead-scan-line" style={{ animationDelay: '2s' }} />
      </svg>
    </div>
  );
};

export default AgentProcessVisualizer;